<template>
  <div>
    <el-tree
      ref="tree"
      :data="TreeData"
      node-key="ClassId"
      :default-expand-all="true"
      :props="defaultProps"
      :check-on-click-node="true"
      :expand-on-click-node="false"
      @node-click="onSelect"
      @node-contextmenu="openMenu"
    >
      <span class="custom-tree-node" slot-scope="{ node }">
        <span :class="{'current-node':node.isCurrent}">{{ node.label }}</span>
        <span>
          <!-- <el-button type="text" @click="create(data)" icon="el-icon-circle-plus-outline"></el-button> -->
        </span>
      </span>
    </el-tree>
    <!-- <ul v-show="visible" :style="{left:menu.left+'px',top:menu.top+'px'}" class="contextmenu">
      <li @click="edit(menu.selectedTag)">编辑</li>
      <li @click="del(menu.selectedTag)">删除</li>
    </ul> -->
    <edit-dialog ref="editDialog" @close-saved="getData" />
  </div>
</template>
<script>
import editDialog from "./editDialog";
import api from "@/api/ed/class";
export default {
  components: { editDialog },
  data() {
    return {
      TreeData: [],
      defaultProps: {
        children: "children",
        label: "ClassName",
      },
      nowId: null,
      visible: false,
      menu: {
        top: 0,
        left: 0,
        selectedTag: {},
      },
      // api: require("@/api/ed/class").default,
      api,
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    // this.getData()
  },
  methods: {
    getData(id) {
      api.gradeClassList(id).then((res) => {
        sessionStorage.setItem("termId",id)
        this.TreeData = this.$commonJs.toTreeData(res.Data, "ClassId");
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.nowId);
        });
      });
    },
    resetSelect() {
      this.$refs.tree.setCurrentKey(null);
    },
    create(data) {
      console.log("create", data);
      let parent = {};
      if (data != undefined) {
        parent = { Pid: data.ClassId, PName: data.ClassName};
      }
      this.$refs.editDialog.openCreate(parent);
    },
    edit(data) {
      this.$refs.editDialog.openEdit(data);
    },
    del(data) {
      console.log(data);
      this.$confirm("确认删除分类吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ id: data.ClassId }).then((res) => {
            console.log(res);
            this.getData();
          });
        })
        .catch(() => {});
    },
    openMenu(e, data) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth + 56; // left boundary
      const left = e.clientX - offsetLeft + 71; // 15: margin right

      if (left > maxLeft) {
        this.menu.left = maxLeft;
      } else {
        this.menu.left = left;
      }

      this.menu.top = e.clientY;
      this.visible = true;
      this.menu.selectedTag = data;
    },
    closeMenu() {
      this.visible = false;
    },
    onSelect(data) {
      if(data.Lv == 1) {
        this.nowId = data.ClassId;
        data.GradeId = -data.ClassId
        this.$emit("on-pselect", data);
      } else {
        this.nowId = data.ClassId;
        sessionStorage.setItem("classId", data.ClassId)
        this.$emit("on-select", data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 40px;
  padding-right: 8px;
}
.el-button {
  font-size: 18px;
}
.current-node {
  color: #409eff;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;
    &:hover {
      background: #eee;
    }
  }
}
/deep/ .el-tree-node__children{
  /deep/ .el-tree-node{
    height: 30px;
  }
  /deep/ .el-tree-node__content{
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
}
</style>